export type FloorRasterModeInput = {
  hasDxfFloor: boolean;
  simulationPanelOpen: boolean;
  simulationRunning: boolean;
  view3dSimulation: boolean;
  view3dOpen?: boolean;
};

/** Match 2D SimulationFloorPlanImage2D — geometry + visibility, not floor name. */
export function hasVisibleDxfFloorGeometry(input: {
  visible: boolean;
  polylines: readonly unknown[];
  bounds?: { minX: number; maxX: number; minY: number; maxY: number } | null;
}): boolean {
  return input.visible && input.polylines.length > 0 && Boolean(input.bounds);
}

/** Single mode contract shared by the 2D and 3D swap points. */
export function shouldUseSimulationDxfRaster(input: FloorRasterModeInput): boolean {
  return (
    input.hasDxfFloor &&
    (input.view3dOpen === true ||
      input.simulationRunning ||
      input.view3dSimulation)
  );
}


